// extracted by mini-css-extract-plugin
module.exports = {"actions":"home-module--actions--3PEt9","homeTxt":"home-module--homeTxt--218P_","projects":"home-module--projects--3TLXr","project":"home-module--project--3mdLv"};